var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social_links",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "container",
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instagram",
    className: "st1",
    d: "M15.6,10.4h8.8c2.8,0,5.2,2.3,5.2,5.2v8.8c0,2.8-2.3,5.2-5.2,5.2h-8.8c-2.8,0-5.2-2.3-5.2-5.2 v-8.8C10.4,12.8,12.8,10.4,15.6,10.4L15.6,10.4z M25.1,13.8L25.1,13.8c0.6,0,1.1,0.5,1.1,1.1l0,0c0,0.6-0.5,1.1-1.1,1.1l0,0 c-0.6,0-1.1-0.5-1.1-1.1l0,0C24,14.3,24.5,13.8,25.1,13.8L25.1,13.8z M20,14.8L20,14.8c2.9,0,5.3,2.4,5.3,5.2l0,0 c0,2.9-2.4,5.2-5.2,5.2l0,0c-2.8,0-5.2-2.3-5.2-5.2l0,0C14.8,17.2,17.1,14.8,20,14.8L20,14.8z M20,16.6L20,16.6 c1.9,0,3.5,1.6,3.5,3.4l0,0c0,1.9-1.6,3.5-3.4,3.5l0,0c-1.9,0-3.4-1.6-3.4-3.5l0,0C16.5,18.1,18.1,16.6,20,16.6L20,16.6z M15.6,12.1 h8.7c2,0,3.6,1.6,3.6,3.6v8.7c0,2-1.6,3.6-3.6,3.6h-8.7c-2,0-3.6-1.6-3.6-3.6v-8.7C12.1,13.7,13.7,12.1,15.6,12.1L15.6,12.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/social-instagram.56cef625a09a2ffe5733d98882075984.svg";
export { ForwardRef as ReactComponent };